import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageSkeleton } from '@/components/ui/page-skeleton';

const fichasSearchSchema = z.object({
  busqueda: z.string().trim().min(1).max(150).optional().catch(undefined),
});

export const Route = createFileRoute('/admin/recet/fichas/')({
  validateSearch: fichasSearchSchema,
  pendingComponent: PageSkeleton,
});
